import gsap, { Power4 } from 'gsap'

import { qs, qsa } from '../utils'
import scroll from '../animations/scroll/locomotiveScroll'

export default class DefaultFiltering {
  beforeEnter({ next }) {
    this.wrapper = qs('.c-filters', next.container)
    this.grid = qs('.layout-grid')
    this.content = qs('[data-content]', this.wrapper)
    this.items = qsa('button', this.content)
    this.animItems = [qs('p', this.content), ...qsa('li', this.content)]
    this.cards = qsa('article')
    this.toggle = qs('[data-toggle]', this.wrapper)
    this.close = qs('[data-close]', this.wrapper)
    this.filtersOpen = false
    this.activeCategory = ''

    this.initListeners()
    this.items.find(item => item.getAttribute('value') === '').classList.add('active')
  }

  beforeLeave() {
    this.removeListeners()
  }

  initListeners() {
    this.handleToggle = this.handleToggle.bind(this)
    this.handleItems = this.handleItems.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)

    this.wrapper.addEventListener('click', this.handleClickOutside)
    this.toggle.addEventListener('click', this.handleToggle)
    this.close.addEventListener('click', this.handleToggle)
    this.items.forEach(item => {
      item.addEventListener('click', this.handleItems)
    })
  }

  removeListeners() {
    this.toggle.removeEventListener('click', this.handleToggle)
    this.close.removeEventListener('click', this.handleToggle)
    this.wrapper.removeEventListener('click', this.handleClickOutside)
    this.items.forEach((item, i) => {
      item.removeEventListener('click', this.handleItems)
    })

  }

  handleItems(e) {
    if (this.animating) return

    if (e.target.getAttribute('value').length) {
      this.activeCategory = e.target.getAttribute('value')
    } else {
      this.activeCategory = ''
    }

    this.items.forEach(item => {
      item.classList.remove('active')
    })

    e.target.classList.add('active')

    this.handleToggle()
    this.animateCards()
  }

  animateCards() {
    const tl = gsap.timeline({ onComplete: () => { scroll.update() } })

    tl
      .to(this.grid, {
        duration: 0.8,
        autoAlpha: 0,
        y: 40,
        ease: Power4.easeOut
      })
      .add(() => { this.setCards() })
      .to(this.grid, {
        duration: 0.8,
        autoAlpha: 1,
        y: 0,
        ease: Power4.easeOut
      })
  }

  setCards() {
    this.cards.forEach(card => {
      if (!this.activeCategory.length) {
        card.style.display = ''
      } else if (this.activeCategory.length && this.activeCategory === card.getAttribute('data-filter')) {
        card.style.display = ''
      } else {
        card.style.display = 'none'
      }
    })
  }

  handleClickOutside(e) {
    if (e.target === this.wrapper && !this.animating) {
      this.handleToggle()
    }
  }

  handleToggle() {
    if (this.animating) return

    this.animating = true
    this.filtersOpen = !this.filtersOpen
    this.wrapper.classList[this.filtersOpen ? 'add' : 'remove']('open')
    this[this.filtersOpen ? 'filtersEnter' : 'filtersLeave']()
  }

  filtersEnter() {
    const tl = gsap.timeline({ onComplete: () => { this.animating = false }})

    tl
      .set(this.wrapper, { visibility: 'visible' })
      .fromTo(this.content, {
        autoAlpha: 0
      }, {
        duration: 0.8,
        autoAlpha: 1,
        ease: Power4.easeOut
      })
      .fromTo(this.animItems, {
        autoAlpha: 0
      }, {
        duration: 1.2,
        autoAlpha: 1,
        stagger: 0.04,
        ease: Power4.easeOut
      }, '-=0.4')
  }

  filtersLeave() {
    const tl = gsap.timeline({ onComplete: () => { this.animating = false }})

    tl
      .to(this.animItems, {
        duration: 1.2,
        autoAlpha: 0,
        stagger: 0.04,
        ease: Power4.easeOut
      })
      .to(this.content, {
        duration: 0.8,
        autoAlpha: 0,
        ease: Power4.easeOut
      }, '-=0.8')
      .set(this.wrapper, { visibility: 'hidden' })
  }
}